// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"424": "e3271ced318c3004","757": "98a4bbc18cff6dc8",}[chunkId] + ".js"
}